export function formatNumber(n: string | number | null) {
    return Number(n).toLocaleString();
}

export function cutDecimals(number: string | number | null) {
    return String(Number(number));
}

export function nullToUndefined(value: null | Date) {
    return value ? value : undefined;
}
